export const VTMN_DIVIDER_ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const VTMN_DIVIDER_TEXT_POSITION = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
};
